import * as React from 'react';
import { connect } from 'react-redux';
import { CommandBar } from '@fluentui/react';
import { types } from '../../constants/types';
import DownloadAddInsText from './DownloadAddInsText';
import './WdCommandBar.css';

export interface AppProps {
	setShowSettingsPane: Function;
	downloadAddins: {
		showDownloadButton: boolean;
	};
}

export interface AppState {
	//
}

class WdCommandBar extends React.Component<AppProps, AppState> {
	render() {
		const { setShowSettingsPane } = this.props;
		return (
			<div
				className={
					'command-bar-wrapper ' +
					(this.props.downloadAddins.showDownloadButton
						? 'command-bar-wrapper-button-show'
						: 'command-bar-wrapper-button-hidden')
				}>
				<CommandBar
					items={[]}
					farItems={[
						{
							key: 'buyBook',
							iconProps: {
								iconName: 'ReadingMode',
							},
							ariaLabel: 'Buy the book',
							onClick: () => {
								window.open(
									'https://www.amazon.com/dp/022635198X/ref=nosim?tag=helensword0d-20',
								);
							},
						},
						{
							key: 'getApp',
							iconProps: {
								iconName: 'WordLogo',
							},
							ariaLabel: 'Get Word App',
							onClick: () => {
								window.open(
									'https://appsource.microsoft.com/en-us/product/office/WA200002125?src=office',
								);
							},
						},
						{
							key: 'help',
							iconProps: {
								iconName: 'Help',
							},
							ariaLabel: 'Help',
							onClick: () => {
								window.open('https://writersdiet.com/writers-diet-help');
							},
						},
						{
							key: 'settings',
							iconProps: {
								iconName: 'Settings',
							},
							ariaLabel: 'Settings',
							onClick: () => {
								setShowSettingsPane();
							},
						},
					]}
				/>
				{this.props.downloadAddins.showDownloadButton && <DownloadAddInsText />}
			</div>
		);
	}
}

const mapStateToProps = ({ downloadAddins }: any) => ({
	downloadAddins,
});
const mapDispatchToProps = (dispatch) => ({
	setShowSettingsPane: () => {
		dispatch({ type: types.SHOW_SETTINGS_PANE });
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(WdCommandBar);
